import { useState } from 'react'
import { BR_VIEWBOX, BR_PATHS, BR_LABELS, BR_LABEL_SIZES } from './brazilGeo'

const UF_LIST = Object.keys(BR_PATHS)

/**
 * Mapa do Brasil clicável por estado. Todos os estados vêm neutros
 * ("desabilitados"); o estado SELECIONADO fica azul. `counts[uf]` é usado só
 * no tooltip (quantidade de credenciados aceitos), não na cor.
 */
export function BrazilMap({ counts, selected, onSelect }: {
  counts?: Record<string, number>
  selected?: string | null
  onSelect: (uf: string) => void
}) {
  const [hover, setHover] = useState<string | null>(null)

  function fill(uf: string): string {
    if (uf === selected) return '#2563eb'   // brand/blue-600 — selecionado
    if (uf === hover)    return '#dbeafe'    // realce suave no hover
    return '#eef2f7'                         // neutro / "desabilitado"
  }

  return (
    <div className="relative w-full">
      <svg viewBox={BR_VIEWBOX} className="w-full h-auto select-none" role="img" aria-label="Mapa do Brasil">
        {UF_LIST.map(uf => (
          <path
            key={uf}
            d={BR_PATHS[uf]}
            fill={fill(uf)}
            stroke={uf === selected ? '#1e3a8a' : '#ffffff'}
            strokeWidth={uf === selected ? 1.6 : 0.8}
            className="cursor-pointer transition-[fill,stroke] duration-150"
            onMouseEnter={() => setHover(uf)}
            onMouseLeave={() => setHover(h => (h === uf ? null : h))}
            onClick={() => onSelect(uf)}
          />
        ))}
        {UF_LIST.map(uf => {
          const [x, y] = BR_LABELS[uf] ?? [0, 0]
          return (
            <text
              key={`l-${uf}`}
              x={x} y={y}
              textAnchor="middle" dominantBaseline="central"
              className="pointer-events-none font-semibold"
              fontSize={BR_LABEL_SIZES[uf] ?? 13}
              fill={uf === selected ? '#ffffff' : '#64748b'}
            >
              {uf}
            </text>
          )
        })}
      </svg>

      {hover && (
        <div className="absolute top-2 right-2 rounded-md bg-gray-900/90 text-white text-xs px-2.5 py-1.5">
          <span className="font-semibold">{hover}</span>
          {counts && <span className="text-gray-300"> · {counts[hover] ?? 0} credenciado(s)</span>}
        </div>
      )}
    </div>
  )
}
